import React, { useState } from 'react'
import { ICONS } from '@Const/common'
import clsx from 'clsx'
import MatchDetailsTable from '@Components/MatchComponents/MatchDetailsTable'
import { RecordingGroup } from '@Entities/matching/recording-group-details'

interface RecordingGroupGridRowProps {
    recordingGroup: RecordingGroup
    showValue: boolean
    showRejectedReason: boolean
}

const RecordingGroupGridRow = ({ recordingGroup, showRejectedReason, showValue }: RecordingGroupGridRowProps) => {
    const [expanded, setExpanded] = useState(false)
    const toggleExpanded = () => setExpanded(!expanded)

    const formatDelimitedString = (str: string | undefined) => {
        if (!str) {
            return str
        }
        return str.replace(/[,|]/, ', ')
    }

    return (
        <>
            <div className="cell-padding-left" role="gridcell">
                {recordingGroup.isrc}
            </div>
            <div role="gridcell">
                <div className="multiline">{recordingGroup.title}</div>
            </div>
            <div role="gridcell">
                <div className="multiline">{formatDelimitedString(recordingGroup?.artist)}</div>
            </div>
            <div role="gridcell">
                <div className="multiline">{formatDelimitedString(recordingGroup?.writers)}</div>
            </div>
            {showValue && (
                <div role="gridcell" className="cell-padding-left">
                    {'$'.repeat(recordingGroup.unmatchedAmount)}
                </div>
            )}
            {showRejectedReason && (
                <div role="gridcell" className={clsx(expanded && 'expanded')}>
                    <div className="multiline">{recordingGroup.rejectionStatusReason}</div>
                </div>
            )}
            <div className="cell-padding-right icons" role="gridcell">
                <img
                    className={clsx('chevron-icon', expanded && 'expanded')}
                    src={ICONS.chevron_drop_down}
                    onClick={toggleExpanded}
                    alt="Expand Icon"
                />
            </div>
            {expanded && (
                <div role="gridcell" className="recording-group-grid-row">
                    <MatchDetailsTable recordings={recordingGroup.recordings} />
                </div>
            )}
        </>
    )
}

export default RecordingGroupGridRow
